import BgSpringArrow from "@/assets/svgs/backgrounds/BgSpringArrow";
import { SectionHeadingType } from "@/components/atoms/SectionHeading";
import CtaButtonGroup, { CtaType } from "@/components/molecules/CtaButtonGroup";
import {
  FeaturesEnum_en,
  HeroPillCategoryEnum_en,
} from "@/shared/data/hero-pills.data";
import {
  FeaturesEnum_kr,
  HeroPillCategoryEnum_kr,
} from "@/shared/data/hero-pills.data.kr";
import Image, { StaticImageData } from "next/image";
import { useRef, useState } from "react";
import Heading from "../atoms/Heading";
import HeroPill from "../atoms/HeroPill";
import HeroStats, { HeroStatsPropsType } from "../atoms/HeroStats";
export type FeatureHeroSectionPropType = {
  heroPill:
    | {
        category: HeroPillCategoryEnum_en.Features;
        subCategory: FeaturesEnum_en;
      }
    | {
        category: HeroPillCategoryEnum_kr.Features;
        subCategory: FeaturesEnum_kr;
      };
  title: SectionHeadingType;
  description: string;
  ctas: CtaType[];
  coverImage: {
    src: StaticImageData | string;
    isVideo?: boolean;
    alt: string;
  };
  heroStatsProps: HeroStatsPropsType;
};

const FeatureHeroSection = ({
  heroPill,
  title,
  description,
  ctas,
  coverImage,
  heroStatsProps,
}: FeatureHeroSectionPropType) => {
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);
  
  const isAiAgent = heroPill.subCategory === FeaturesEnum_en.AiAgent;
  return (
    <div className="container relative pt-8 md:pb-20 md:pt-20 md:text-left">
      {/* <div className="absolute bottom-0 right-1/3 hidden h-screen w-screen rounded-br-[300px] border-b border-r md:block"></div> */}
      <div className="absolute bottom-0 hidden h-screen w-full -translate-x-1/2 rounded-br-[300px] border-b border-r md:block"></div>
      <div className="flex flex-col gap-12 md:flex-row">
        <div className="flex-1">
          <div className="relative flex flex-col items-start gap-3">
            <HeroPill
              category={heroPill.category}
              subCategory={heroPill.subCategory}
            />
            <div className="relative pr-4 md:pr-3">
              <div className={isAiAgent ? "whitespace-nowrap" : ""}>
                <Heading
                  heading={title}
                  fontStyle={isAiAgent ? "text-title-20 sm:text-title-32" : "text-title-32 sm:text-display-64"}
                  as="h1"
                />
              </div>
              <BgSpringArrow className="absolute left-full top-1/2 -translate-y-1/3 scale-75 md:translate-y-0 md:scale-100" />
            </div>
            <p className="max-w-xs text-body-14 text-grey-4">{description}</p>
          </div>
          <div className="relative mt-6 flex flex-col items-start gap-4">
            <CtaButtonGroup ctas={ctas} gap="gap-4" align="md:left" />
            <HeroStats {...heroStatsProps} />
          </div>
        </div>
        <div className="relative flex flex-1 items-center justify-center">
          {coverImage.isVideo ? (
            <div className="relative w-full rounded-2xl overflow-hidden">
              <video 
                src={coverImage.src as string} 
                className="w-full h-auto object-contain"
                autoPlay
                loop
                playsInline
                ref={videoRef}
                muted={isMuted} 
              />
              <button 
                className="absolute bottom-4 right-4 bg-black bg-opacity-50 rounded-full p-2 z-10"
                onClick={() => setIsMuted(!isMuted)}
              >
                {isMuted ? (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.63 3.63a.996.996 0 000 1.41L7.29 8.7 7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91-.36.15-.58.53-.58.92 0 .72.73 1.18 1.39.91.8-.33 1.55-.77 2.22-1.31l1.34 1.34a.996.996 0 101.41-1.41L5.05 3.63c-.39-.39-1.02-.39-1.42 0zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-7-8l-1.88 1.88L12 7.76zm4.5 8c0-1.77-1.02-3.29-2.5-4.03v1.79l2.48 2.48c.01-.08.02-.16.02-.24z"/>
                  </svg>
                ) : (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                  </svg>
                )}
              </button>
            </div>
          ) : (
            <Image
              src={coverImage.src as StaticImageData}
              alt={coverImage.alt}
              priority
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FeatureHeroSection;
